import React from 'react';
import "./mtm-input-calendar.styles.css";

export default function MtmInputCalendar(props) {
    const {label, name, ...others} = props;
    const handleFocus = (event) => {
        var label = document.getElementById("calendar_label");
        label.className = label.className.replaceAll(" focused","");
        label.className += " focused";
    };

    const handleBlur = (event) => {
        var label = document.getElementById("calendar_label");
        label.className = label.className.replaceAll(" focused","");
    };

    return (
        <div className="input-block" >
            <div id="calendar_label" className="calendar-label">{label?label:"Wedding Date (optional)"}</div>
            <input className='calendar flex-input' onBlur={handleBlur} onFocus={handleFocus} min={props.min_date} max={props.max_date} type="date" {...props}/> 
            <div style={{display:props.no_error?"none":""}} className="t-input-error"></div>
        </div>
    )
}